



























import { Component, Prop, Vue } from "vue-property-decorator";
import Tag from "@/components/Tag/Tag.vue";
import Button from "@/components/Button/Button.vue";
import { bestTagShow, getTypeObj } from "@/utils/sku_section";
import { format } from "@/utils/num_utils";

@Component({
  components: {
    Button,
    Tag
  }
})
export default class SkuList extends Vue {
  @Prop({ default: [] })
  private item: any;
  @Prop({ default: "follow" }) // 类型
  private type?: any;

  private bestTagShow(item: any) {
    return bestTagShow(item);
  }

  get typeObj() {
    return getTypeObj(this.type);
  }

  get format() {
    return format;
  }
}
